// extracted by mini-css-extract-plugin
export default {"page":"Contacts_page__D+Qb9","block":"Contacts_block__nLFcc","table":"Contacts_table__nDQey"};